import React from 'react';
import { Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import CommonCompleteCard from '../uiParts/CommonCompleteCard';
import Header from '../uiParts/Header';
import { gray20, gray80 } from '../../constants/colors';
import MetaTitle from '../utils/MetaTitle';
import { headerHeight, spHeaderHeight } from '../../constants/location';

const styles = {
  background: {
    width: '100%',
    height: '100vh',
    backgroundColor: gray20,
  },
  header: {
    height: headerHeight,
    position: 'fixed',
    '@media screen and (max-width:600px)': {
      height: spHeaderHeight,
      width: '100%',
      zIndex: '100',
    },
  },
  icon: {
    fontSize: '56px',
    color: gray80,
    mb: 3,
    '@media screen and (max-width: 600px)': {
      mb: 2,
    },
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    width: '-webkit-fill-available',
    paddingTop: headerHeight,
    '@media (max-width: 600px)': {
      paddingTop: '50%',
      height: 'auto',
      marginLeft: '16px',
      marginRight: '16px',
    },
  },
};

const StaffRegisterComplete = (): React.ReactElement => {
  const icon = <CheckCircleIcon sx={styles.icon} />;
  const title = '担当者の登録が完了しました';
  const textAligin = 'left';
  const description = 'ARGUSへようこそ！\nファイルをアップロードして、読取結果を確認しましょう。';
  const buttonText = 'AI文字読取へ';
  const buttonLink = '/ai-ocr';

  return (
    <Box sx={styles.background}>
      <MetaTitle />
      <Box sx={styles.header}>
        <Header />
      </Box>
      <Box sx={styles.container}>
        <CommonCompleteCard
          icon={icon}
          title={title}
          textAligin={textAligin}
          description={description}
          buttonText={buttonText}
          buttonLink={buttonLink}
        />
      </Box>
    </Box>
  );
};

export default StaffRegisterComplete;
